import icons from "url:../../img/icons.svg";

export default class View {
 _data;
 //RENDER
 render(data, render = true) {
  if (!data || (Array.isArray(data) && data.length === 0)) return this.renderError();
  this._data = data;
  const renderMarkup = this._generateMarkup();
  if (!render) return renderMarkup;
  this._clear();
  this._parentElement.insertAdjacentHTML("afterbegin", renderMarkup);
 }

 update(data) {
  this._data = data;
  const newMarkup = this._generateMarkup();
  const newDOM = document.createRange().createContextualFragment(newMarkup);
  const newElements = Array.from(newDOM.querySelectorAll("*"));
  const currElements = Array.from(this._parentElement.querySelectorAll("*"));
  newElements.forEach((newEl, i) => {
   const curEl = currElements[i];
   if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") {
    curEl.textContent = newEl.textContent;
   }
   if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attr) => curEl.setAttribute(attr.name, attr.value));
  });
 }
 //CLEAR
 _clear() {
  this._parentElement.innerHTML = "";
 }
 //SPINNER
 renderSpinner() {
  const markup = `
  <div class ="spinner">
  <svg>
  <use href='${icons}#icon-loader'></use></svg></div>`;
  this._clear();
  this._parentElement.insertAdjacentHTML("afterbegin", markup);
 }

 renderError(message = this._errorMessage) {
  const markup = `
          <div class="error">
            <div>
              <svg>
                <use href="${icons}#icon-alert-triangle"></use>
              </svg>
            </div>
            <p>${message}</p>
          </div>`;
  this._clear();
  this._parentElement.insertAdjacentHTML("afterbegin", markup);
 }
 renderMessage(message = this._message) {
  const markup = `<div class="recipe">
      <div class="message">
        <div>
          <svg>
            <use href="${icons}#icon-smile"></use>
          </svg>
        </div>
        <p>${message}</p>
      </div>`;
  this._clear();
  this._parentElement.insertAdjacentHTML("afterbegin", markup);
 }
}
